import script from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"

import "./ScreenTitle.vue?vue&type=style&index=0&id=6dba6ffe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba6ffe"]])

export default __exports__